import { render, staticRenderFns } from "./ProductDetailsCardMobile.vue?vue&type=template&id=8ee4d35c&scoped=true&"
import script from "./ProductDetailsCardMobile.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsCardMobile.vue?vue&type=style&index=0&id=8ee4d35c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee4d35c",
  null
  
)

export default component.exports